// Profil-Nachbau F-20, F-21 Muss 7 (output/profil-team-20261014/BAU-INHABER.md, Leiste „Vorgaben für alle Firmen“): Wörter der
// Seiten unter „Vorgaben für alle Firmen“. Die Abschnitte anderer Bereiche bringen ihre eigenen Wörter mit. Den Produktnamen setzt die Seite aus der Marke
// ein (useBrand().displayName, MK-1); der Satz zur gewonnenen Zeit steht in cockpit/cockpitTexte.ts (SO_RECHNET.zeit).
export const VORGABEN_TEXTE = {
  gruppe: 'Vorgaben für alle Firmen',
  recherche: {
    titel: 'Recherche und Kontingent',
    // Profil-Nachbau F-24 (SPEC-verwaltung 2.10): Unterzeilen und Hinweise höchstens 12 Wörter, Vorrang und Herkunft im Tooltip.
    beschreibung: (produkt: string) => `Vorgaben von ${produkt} für alle Firmen und Einzelkonten ohne eigene Einstellung.`,
    laden: 'Die Vorgaben werden geladen …',
  },
  zeit: {
    titel: 'Gewonnene Zeit',
    beschreibung: 'So rechnet das KI-Cockpit die gewonnene Zeit.',
    sichtbar: (an: boolean) => an ? 'Im KI-Cockpit der Firmen sichtbar.' : 'Im KI-Cockpit der Firmen ausgeblendet.',
    aendern: 'Regel ändern …',
    fehler: 'Die Regel konnte nicht geladen werden.',
    nochmals: 'Erneut versuchen',
  },
  // PF-412-3 (F-09, F-20): der Abschnitt „Websuche“ (vorgaben/WebsucheStandard.tsx), der Standard für Firmen ohne eigene Vorgabe,
  // Einzelkonten und Konten ohne Firma.
  websuche: {
    titel: 'Websuche',
    zeile: 'Websuche bei Recherchen erlauben',
    erklaerung: 'Gilt für alle ohne eigene Vorgabe.',
    tipp: 'Eine Firma kann für sich anders entscheiden; die Wahl einer Person gilt nur, wenn ihre Firma die Websuche erlaubt.',
    google: 'Bei der Websuche gehen aus der Frage gebildete Suchbegriffe an die Google-Suche.',
    nichtSchaltbar: 'In dieser Recherche-Art nicht verfügbar.',
    gespeichert: 'Gespeichert. Gilt ab der nächsten Recherche.',
    fehler: 'Die Einstellung konnte nicht gespeichert werden.',
    ohneRecht: 'Ändern dürfen Konten mit dem Recht „Systemeinstellungen ändern“.',
    laden: 'Der Websuche-Standard wird geladen …',
    ladefehler: 'Der Websuche-Standard konnte nicht geladen werden.',
    nochmals: 'Erneut versuchen',
  },
  // PF-412-2 (F-20 Ergänzung 4, FRAGEN.md F-I4): der Abschnitt „Glossar“ (vorgaben/GlossarPflegen.tsx). wirkung nennt, ob die
  // Recherche das Glossar schon liest; seit PF-732 liest sie es (AUFTRAG-PF-412-2 Satz für den committeten Stand).
  glossar: {
    titel: 'Glossar',
    beschreibung: (_produkt: string) => 'Abkürzungen und Langformen, die bei der Suche gleich gelten.',
    tipp: (produkt: string) => `${produkt} bringt gängige österreichische Abkürzungen mit; Sie können sie ändern, ergänzen oder ausschalten. Firmen ergänzen eigene Begriffe.`,
    wirkung: 'Die Recherche berücksichtigt die aktiven Begriffe ab der nächsten Frage.',
    kurz: 'Abkürzung',
    lang: 'Langform',
    aktiv: 'Aktiv',
    aktionen: 'Aktionen',
    aktivName: (kurz: string) => `${kurz} aktiv`,
    vorbefuellt: 'Vorbefüllt',
    neu: 'Begriff hinzufügen',
    hinzufuegen: 'Hinzufügen',
    bearbeiten: 'Bearbeiten …',
    bearbeitenTitel: (kurz: string) => `„${kurz}“ bearbeiten`,
    speichern: 'Speichern',
    abbrechen: 'Abbrechen',
    entfernenFragen: 'Entfernen …',
    rueckfrage: (kurz: string) => `„${kurz}“ entfernen? Der Begriff gilt danach für keine Firma mehr.`,
    entfernen: 'Entfernen',
    zaehler: (aktiv: number, gesamt: number) => `${aktiv} von ${gesamt} Begriffen aktiv`,
    suche: 'Glossar durchsuchen',
    leer: 'Noch keine Begriffe.',
    keinTreffer: 'Kein Begriff gefunden.',
    gespeichert: 'Gespeichert.',
    ohneRecht: 'Ändern dürfen Konten mit dem Recht „Systemeinstellungen ändern“.',
    laden: 'Das Glossar wird geladen …',
    fehler: 'Das Glossar konnte nicht geladen werden.',
    nochmals: 'Erneut versuchen',
  },
} as const;
